<template>
  <div class="container">
    <QueryFrame @handlePage='handlePage' @handlePageSize='handlePageSize' :disablePage='disablePage'
      :current='page' :count='count'>
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>医院名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.name'></lk-input>
          </div>
          <div class="queryItem">
            <label>所属省市:</label>
            <location :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.locationArr' />
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select :maxlength='100' class="item" clearable v-model.trim='query.status'>
              <lk-option v-for="(item,index) in statusList " :key="index" :value='index'>{{item}}
              </lk-option>
            </lk-select>

          </div>


          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb16">
          <lk-button class="mr8" type='primary' v-if="handlePermission('hospitalAdd')"
            @click='handleHospitalModal(true)'>+ 新建处方医院</lk-button>
          <DownloadButton @on-click="download" v-if="handlePermission('hospitalExport')">
          </DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal title="处方医院" v-model="hospitalModal">

      <div>
        <lk-form label-position="right" :label-width="80" :rules='hospitalRule' :model='hospital'
            ref="hospitalForm" >
          <lk-row>
            <lk-form-item label='医院名称:' prop='name'>
              <lk-input v-model="hospital.name"></lk-input>
            </lk-form-item>
            <lk-form-item label='医院地址:'>
              <location v-model="hospital.locationArr"></location>
            </lk-form-item>
            <lk-form-item label='详细地址:'>
              <lk-input v-model="hospital.address"></lk-input>
            </lk-form-item>
          </lk-row>
        </lk-form>
      </div>
      <div slot="footer">
        <lk-button @click="hospitalModal=false">取消</lk-button>
        <lk-button @click="handleSubmit" type='primary' :loading='submitLoading' >确认</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
// import supplier from '../../services/supplier';
import base from '../../../services/base';
// import DtpDatePicker from '../../components/DtpDatePicker.vue';
import utils from '../../../libs/utils';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';
import DownloadButton from '../../../components/download/DownloadButton';
import location from '../../../components/location';

// const { hospital } = base;
export default {
  name: 'HospitalList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
    location,
  },
  data() {
    return {
      hospitalRule: {
        name: [{
          required: true, message: '请填写医院名称', trigger: 'blur',
        }],
      },
      submitLoading: false,
      hospital: {},
      statusList: {
        1: '启用',
        2: '禁用',
        // 3: '删除',
      },
      query: {
        duration: [],
        source: null,

        patientName: null,
        consigneePhone: null,
        doctor: null,
        status: null,
      },
      columns: [{
        title: '医院编码',
        key: 'code',
        minWidth: 116,
      },
      {
        title: '医院名称',
        key: 'name',
        minWidth: 116,
      },
      {
        title: '所属省市',
        key: 'detailAddress',
        minWidth: 116,
      },

      {
        title: '创建人',
        key: 'createUserName',
        minWidth: 116,
      },
      {
        title: '创建时间',
        key: 'createTimeStr',
        minWidth: 116,
      },

      {
        title: '最后修改人',
        key: 'modifiedUserName',
        minWidth: 116,
      },
      {
        title: '最后修改时间',
        key: 'modifiedTimeStr',
        minWidth: 116,
      },
      {
        title: '状态',
        key: 'statusStr',
        minWidth: 116,
        fixed: 'right',
        render: (h, params) => (this.handlePermission('editStatusHospital') ? h(
          'lk-switch', {
            props: {
              size: 'large',
              value: params.row.status === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (e) => {
                params.row.loading = true;
                const hospital = utils.deepClone(params.row);
                hospital.status = e ? 1 : 2;
                base.hospital.editStatusHospital({ hospital }).then((responseData) => {
                  if (responseData.data.status === 200) {
                    const message = e ? '启用成功' : '禁用成功';
                    params.row.loading = false;
                    this.$Message.success(message);
                  }
                }).catch((err) => {
                  utils.handleError(err);
                });
              },
            },
          }, [
            h('span', {
              props: {},
              slot: 'open',

            }, '启用'),
            h('span', {
              props: {},
              slot: 'close',

            }, '禁用'),
          ],
        ) : h('span', params.row.status === 1 ? '启用' : '禁用')),
      },

      {
        title: '操作',
        key: 'action',
        width: 200,
        fixed: 'right',
        render: (h, params) => (this.handlePermission('hospitalEdit') ? h(
          'lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on: {
              click: () => {
                const { provinceId, cityId, countyId } = params.row;
                this.hospital = Object.assign(this.hospital, params.row);
                this.hospital.locationArr = [
                  provinceId, cityId, countyId,
                ];
                this.hospitalModal = true;
              },
            },
          }, '编辑',
        ) : null),
      },
      ],
      tableData: [],
      // page: 1,
      // size: 10,
      // count: 0,
      // localtion: [],
      // kmCode: '',
      hospitalModal: false,
    };
  },
  methods: {
    exchangeLocation(locationArr) { // 处理位置数组转换
      if (!locationArr || !locationArr.length) {
        return {};
      }
      const [provinceId, cityId, countyId] = locationArr;
      return {
        provinceId, cityId, countyId,
      };
    },
    handleSubmit() {
      let submitFunc = null;

      this.$refs.hospitalForm.validate((valid) => {
        if (valid) {
          if (this.hospital.id) {
            submitFunc = base.hospital.editHospital;
          } else {
            // submitFunc = 2;
            submitFunc = base.hospital.addHospital;
          }

          this.hospital = Object.assign(this.hospital, this.exchangeLocation(this.hospital.locationArr));
          this.submitLoading = true;
          delete this.hospital.status;


          this.$store.commit('setDisableLoading', true);
          submitFunc({ hospital: this.hospital }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.hospitalModal = false;
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
            this.submitLoading = false;
            this.getData();
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        }
      });
    },
    handleHospitalModal(isNew) {
      if (isNew) {
        this.hospital = {};
      }
      this.hospitalModal = true;
    },
    download() {
      let params = utils.deepClone(this.params);
      params.page = 0;
      params.size = 0;
      params = Object.assign(params, this.exchangeLocation(params.locationArr));
      // params.duration && ([params.createTimeStart, params.createTimeEnd] = params.duration);
      // delete params.duration;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.type = 2;
      base.hospital.downloadHospitalList(params).then((res) => {
        // utils.downLoadExcel(res, '处方药销售记录查询');
        if (res.status !== 200) {
          this.$Message.error(res.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    clear() {
      this.query = {
        duration: [],
        source: null,

        patientName: null,
        consigneePhone: null,
        doctor: null,
        status: null,
      };
    },
    // getlocaltions() {

    // },
    // loadLocaltion() {

    // },
    // handleSearch() {
    //   this.params = Object.assign(this.params, this.query);
    //   this.handlePage(1, true);
    // },
    // getSourceList() {
    //   sale.getSourceList().then((res) => {
    //     if (res.data.status === 200) {
    //       this.sourceList = res.data.data;
    //     } else {
    //       this.$Message.error(res.data.error);
    //     }
    //   }).catch((err) => {
    //     utils.handleError(err);
    //   });
    // },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;

      this.params = Object.assign(this.params, this.exchangeLocation(this.params.locationArr));
      // this.params.duration && ([this.params.createTimeStart, this.params.createTimeEnd] = this
      //   .params.duration);
      // delete this.params.duration;
      // this.params.type = 2;
      base.hospital.getHospitalList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = utils.deepClone(item);
            // result.proceedsAmount = item.proceedsAmount;
            // result.orderStatusName = item.orderStatusName;
            result.createTimeStr = utils.formatTime(result.createTime);
            result.modifiedTimeStr = utils.formatTime(result.modifiedTime);
            result.statusStr = this.statusList[result.status];
            // result.paymentStatusString = this.publicParams.judgeList[result.paymentStatus];
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    addNew() {
      this.$router.push({
        name: 'supplierGeneralAdd',
      });
    },

  },
  mounted() {
    // this.getSourceList();
    this.handleSearch(true);
  },
};

</script>

<style lang="less" scoped>
  // .form {
  // margin-top: 16px;
  // padding-bottom: 24px
  // // }
  // .extraItem{
  //   display: flex;
  //   align-items: center;
  //   margin-bottom: 13px;
  //   >*{
  //     margin-right: 8px;
  //     // flex-shrink: 0

  //   }
  // }

</style>
